import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CallCenterCallTimerService {
  private startTime = 0;
  private elapsedTime = 0;
  private timerSubscription: Subscription | null = null;
  private timerSubject = new BehaviorSubject<string>('0:00');
  private isRunningSubject = new BehaviorSubject<boolean>(false);

  timer$ = this.timerSubject.asObservable();
  isRunning$ = this.isRunningSubject.asObservable(); // Observable for running status

  start(): void {
    if (this.timerSubscription) return;

    this.startTime = Date.now() - this.elapsedTime;
    this.isRunningSubject.next(true); // Set running status to true
    this.timerSubscription = interval(1000)
      .pipe(
        map(() => {
          this.elapsedTime = Date.now() - this.startTime;
          const formattedTime = this.formatTime(this.elapsedTime);
          return this.formatTime(this.elapsedTime);
        }),
      )
      .subscribe((formattedTime) => this.timerSubject.next(formattedTime));
  }

  stop(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
      this.isRunningSubject.next(false);
    }
  }

  reset(): void {
    this.elapsedTime = 0;
    this.timerSubject.next('0:00');
    this.isRunningSubject.next(false);
  }

  getCurrentValue(): string {
    return this.timerSubject.value;
  }

  getElapsedMilliseconds(): number {
    return this.elapsedTime;
  }

  private formatTime(milliseconds: number): string {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}
